import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "@/store/auth";

/**
 * Passes for all internal users and for contractor accounts with has_friday_access=true.
 */
export function FridayGuard() {
  const user = useAuthStore((s) => s.user);
  if (!user) return <Navigate to="/auth/login" replace />;
  const isInternal = user.role !== "contractor";
  const hasAccess = isInternal || (user.role === "contractor" && user.has_friday_access);
  if (!hasAccess) return <Navigate to="/" replace />;
  return <Outlet />;
}
